/**
 * Firebase configuration for Admin Portal
 * Uses the same Firebase project as GUS (silacitiesrcrcapp)
 */

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Development mode check
export const isDevelopment = process.env.NODE_ENV === 'development';

// Validate Firebase configuration
export const validateFirebaseConfig = (): boolean => {
  const requiredFields = ['apiKey', 'authDomain', 'projectId'];

  for (const field of requiredFields) {
    if (!firebaseConfig[field as keyof typeof firebaseConfig]) {
      console.error(`Missing required Firebase config: ${field}`);
      return false;
    }
  }

  return true;
};

// Allowed email domains for authentication
export const ALLOWED_DOMAINS = ['@silacities.com', '@silainsights.com'];

// Check if email is from allowed domain
export const isAllowedEmail = (email: string): boolean => {
  if (!email) return false;
  const emailLower = email.toLowerCase();
  return ALLOWED_DOMAINS.some(domain => emailLower.endsWith(domain));
};

export default firebaseConfig;
